import { useCallback, useEffect, useState } from 'react';

import { useFormContext } from 'react-hook-form';

const useScrollToError = () => {
  const methods = useFormContext();
  const [submitting, setSubmitting] = useState(false);

  const startSubmitting = () => {
    setSubmitting(true);
  };

  const handleScrollToError = useCallback(() => {
    const firstErrorId =
      Object.keys(methods.formState.errors).length > 0
        ? Object.keys(methods.formState.errors)[0]
        : null;

    const everyErrorPosition = Object.keys(methods.formState.errors).map(
      (key) => {
        return {
          element: document.getElementById(key),
          position: document.getElementById(key)?.getBoundingClientRect().top,
        };
      }
    );

    if (firstErrorId && everyErrorPosition && everyErrorPosition.length > 0) {
      const firstError = everyErrorPosition.reduce((prev, current) =>
        prev.position && current.position && prev.position <= current.position
          ? prev
          : current
      );

      if (firstError.element) {
        setTimeout(() => {
          firstError.element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }, 200);
      }
    }
  }, [methods.formState.errors]);

  useEffect(() => {
    if (submitting) {
      handleScrollToError();
      setSubmitting(false);
    }
  }, [submitting, methods.formState, handleScrollToError]);

  return { startSubmitting };
};

export default useScrollToError;
